import React from "react";
import { motion } from "framer-motion";
import EtVideoPanel2 from "@/components/media/EtVideoPanel2";
import { LightBulbIcon } from "@heroicons/react/24/solid";

const EtThinkWareLibrary = () => {
  const episodes = [
    {
      id: "ep1",
      title: "#1 - Why Most Playbooks Stall?",
      desc: "A deep dive...",
      videoId: "btIzyH7RW_E", // Chapter 1 - Driving Growth
      prompts: [
        "What belief about growth have you carried unconsciously?",
        "Where does your thinking drift from your intent?",
        "What is one small shift you'd like to make?"
      ]
    },
    {
      id: "ep2",
      title: "#2 - What are you after?",
      desc: "Speed or Effectiveness...",
      videoId: "KqWjDBibQI8", // Chapter 2 - Speed Or Effectiveness
      prompts: [
        "What drives your decision making?",
        "What deliberations do you do before you start?",
        "What are you willing to let go for success?"
      ]
    },
    {
      id: "ep3",
      title: "#3 - What will make you win more with AI?",
      desc: "Human in the loop or...",
      videoId: "7BfpH2zHaI0", // Chapter 3 - The Focus
      prompts: [
        "Who are you thinking about when you envision growth?",
        "Where does your thinking drift from your intent?",
        "What is one small shift you'd like to make?"
      ]
    },
    {
      id: "ep4",
      title: "#4 - What are your growth thinking gaps?",
      desc: "Growth is not a desire...",
      videoId: "g-8SGHcIAq0",// Chapter 4 - The Gaps
      prompts: [
        "What does purpose mean in your work today?",
        "Where do you see misalignment?",
        "What tension are you choosing to ignore?"
      ]
    },
    {
      id: "ep5",
      title: "#5 - How would you approach growth in a new environment?",
      desc: "What and when...",
      videoId: "ddfkioJ7xhU",// Chapter 5 - The New Environment
      prompts: [
        "What's on your mind as you look at your new org?",
        "What would you do in the initial days?",
        "What would you share with your new org?"
      ]
      // prompts: [
      //   "What belief about growth have you carried unconsciously?",
      //   "Where does your thinking drift from your intent?",
      //   "What is one small shift you'd like to make?"
      // ]
    },
    {
      id: "ep6",
      title: "#6 - What's your team leverage for driving growth?",
      desc: "High performing teams don't happen by chance....",
      videoId: "H8kqCbXajHw",// Chapter 6 - The Team Leverage
      prompts: [
        "How do you define high performance team?",
        "What is really driving your team's performance?",
        "What can change your team's performane?"
      ]
    },
    {
      id: "ep7",
      title: "#7 - What's the return on your team's investment?",
      desc: "Indifference, impatience or...",
      videoId: "aQHdhbANNVo", // Chapter 7 - The Team Performance
      prompts: [
        "What makes people take self-initiative?",
        "What do they value the most?",
        "What can shift their motivation?"
      ]
    },
    {
      id: "ep8",
      title: "#8 - Are you a growth inhibitor?",
      desc: "Growth a wishful desire or...",
      videoId: "MVMtIyyK1b0",// Chapter 8 - The CxO inspiration
      prompts: [
        "What environment do you need to create?",
        "What do you need to scale down?",
        "Where do you need to scale up?",
      ]
    },  
  ];

  return (
    <section
        id="thinkware-episodes"
        className="relative pb-24 bg-black text-white overflow-hidden"
    >
        {/* Animated Pulsating Gradient Background */}
        <div className="absolute inset-0">
            {/* Base gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-900/20 to-black" />
            
            {/* Pulsating radial orange glow */}
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,102,0,0.25)_0%,transparent_70%)] mix-blend-screen animate-[pulse_10s_ease-in-out_infinite]" />
        </div>


        {/* ---------------------------------------------- */}
        {/* LIBRARY HEADER */}
        {/* ---------------------------------------------- */}
        <div className="relative z-10 max-w-3xl mx-auto text-center mb-20">
          <h2 className="text-3xl md:text-6xl font-bold text-orange-600 mb-4 leading-relaxed">
            <span className="text-white">Building</span> Purpose Native <span className="text-white">Organizations :</span> The Growth <span className="animate-pulse">Thinking</span>
          </h2>

        </div>
        
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-32">

        {episodes.map((ep, index) => {
          const isEven = index % 2 === 0;

          return (
            <motion.div
              key={ep.id}
              className="grid md:grid-cols-2 gap-12 items-start"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              {/* Video */}
              <div className={`${isEven ? "" : "md:order-2"}`}>
                <EtVideoPanel2
                  videoId={ep.videoId}
                //   className="w-full h-64 sm:h-80 md:h-[25rem] lg:h-[28rem] rounded-xl overflow-hidden shadow-xl"
                />
              </div>

              {/* Text */}
              <div
                className={`
                    relative ${isEven ? "" : "md:order-1"}
                    p-1 rounded-xl h-full
                `}
                >
                {/* BACKDROP TO PROTECT TEXT */}
                <div className="absolute inset-0 bg-black/60 backdrop-blur-sm rounded-xl pointer-events-none" />

                {/* TEXT CONTENT */}
                <div className="relative z-10 ">
                    <h3 className="text-3xl font-light text-orange-500 mb-4 p-2">
                    {ep.title}
                    </h3>

                    <p className="text-gray-200 text-lg leading-relaxed mb-6 p-2 ">
                    {ep.desc}
                    </p>

                    <p className="text-orange-400 font-semibold mb-2 p-2">
                    Reflection Prompts:
                    </p>

                    <ul className="space-y-3 text-gray-300 text-base font-extralight p-2">
                      {ep.prompts.map((q, qi) => (
                        <li key={qi} className="flex items-start gap-3">
                          <LightBulbIcon className="h-5 w-5 text-orange-500 shrink-0 mt-0.5 animate-pulse" />
                          <span>{q}</span>
                        </li>
                      ))}
                    </ul>

                    {/* <ul className="space-y-2 text-gray-300 text-base font-extralight p-2">
                    {ep.prompts.map((q, qi) => (
                        <li key={qi}>• {q}</li>
                    ))}
                    </ul> */}
                </div>
                </div>

            </motion.div>
          );
        })}

      </div>
    </section>
  );
};

export default EtThinkWareLibrary;
